import ElTag from './src/tag';

export default ElTag;
